import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NavItem } from '../shared/models/nav-item.model';

export type UserRole = 'ADMIN' | 'USER';
export type UserAccountType = 'ADMIN' | 'USER';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
private http = inject(HttpClient);

  getMenuByRole(role: UserRole): Observable<NavItem[]> {
    const file =
      role === 'ADMIN'
        ? 'assets/navigation/admin.menu.json'
        : 'assets/navigation/user.menu.json';

    return this.http.get<NavItem[]>(file);
  }

  getMenuByAccountType(role: UserAccountType): Observable<NavItem[]> {
    const file =
      role === 'ADMIN'
        ? 'assets/navigation/admin.menu.json'
        : 'assets/navigation/user.menu.json';

    return this.http.get<NavItem[]>(file);
  }
}
